import { Trans, Translation } from 'react-i18next';
import React from 'react';

export const Participation = [
  {
    label: <Translation>{t => t('LuckyDraw_fields.1ynert1')}</Translation>,
    name: 'operations.follow_creator',
    disabled: false,
    disabledTip: <Trans i18nKey="LuckyDraw_fields.disableTip"></Trans>,
  },
  // {
  //   label: 'Repost this post',
  //   name: 'operations.repost_article',
  // },
];
